import React from "react";
import capitalize from "lodash/capitalize";
import { withTranslation } from "react-i18next";

import Modal from "../modal-new";
import UnitInput from "../inputs/unit-input-exercise-library";
import ExtraInputComponent from "../other-exercise/ExtraInputComponent";
import { MOVEMENTS, PRIMARIES_WITHOUT_SUFFIX } from "../../constants";
import { RillContext } from "../../rill/RillReact/share/base";

const id = "modal-add-secondary-movement";

class AddSecondaryMovementModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    let initialState;
    if (!this.props.isNew) {
      const {
        video,
        exerciseTypeField,
        primaryMuscleGroup,
        secondaryMuscleGroup,
        instructions,
      } = this.props.exercise || this.props.library[this.props.index];

      initialState = {
        videoUrl: (video && video.url) || "",
        videoFile: null,
        videoOriginal: (video && video.videoOriginal) || "", // if there is an uploaded video
        exerciseTypeField: exerciseTypeField || "",
        primaryMuscleGroup: primaryMuscleGroup || "",
        secondaryMuscleGroup: secondaryMuscleGroup || "",
        instructions: instructions || "",
        videoDeleteOtherExercise: null,
      };
    }

    this.state = Object.assign({}, initialState);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.cleanVideoField = this.cleanVideoField.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  }

  cleanVideoField() {
    this.setState({ videoOriginal: "", videoDeleteOtherExercise: true });
  }

  render() {
    const { t } = this.props;
    const {
      videoUrl,
      videoFile,
      videoOriginal,
      exerciseTypeField,
      primaryMuscleGroup,
      secondaryMuscleGroup,
      instructions,
      videoDeleteOtherExercise,
    } = this.state;

    const {
      isNew,
      index,
      athlete,
      library,
      primary,
      user,
      isCatalog,
      exercise,
    } = this.props;
    const repMax =
      !isNew && primary !== "assistant"
        ? library[index]?.repMaximum
        : user.repMaximums[primary];
    const value = exercise
      ? exercise.movement
      : (!isNew && library[index].movement) || "";

    let forAthlete = "";
    if (athlete) {
      forAthlete = `?forAthlete=${athlete._id}`;
    }

    let formURL = isNew
      ? `/actions/user/add-secondary${forAthlete}`
      : `/actions/user/edit-secondary/${index}${forAthlete}`;

    if (isCatalog) {
      formURL = `/actions/exercise-catalog/save/${
        exercise ? exercise._id : ""
      }`;
    }

    const default1RMValue = athlete
      ? repMax
      : library[index] !== undefined
      ? library[index].repMaximum
      : 100;

    const modalTitle = primary
      ? t("addSecondaryMovement.variationTitle", {
          primary: MOVEMENTS[primary] ?? capitalize(primary),
        })
      : t("addSecondaryMovement.variationMovement");

    return (
      <form
        action={formURL}
        method="POST"
        data-noreset
        encType="multipart/form-data"
        id="add-secondary-exercise"
      >
        <input name="source" value="settings" type="hidden" />
        <Modal
          title={`${isNew ? t("common:add") + " " : t("common:edit") + " "}${
            primary == "assistant"
              ? t("addSecondaryMovement.assistantMovement")
              : modalTitle
          }`}
          name={id}
          key={id}
          width="600px"
          toClear={["exercise"]}
          className={"add-movement-modal"}
        >
          <div className="body">
            <input type="hidden" name="primary" value={primary} />
            <input
              name="videoDeleteOtherExercise"
              value={videoDeleteOtherExercise}
              type="hidden"
            />

            <div>
              <div className="w-1/2 mb-6">
                <label>{t("addSecondaryMovement.nameLabel")}</label>
                <div className="load-suffix-input-container">
                  <input
                    className="padding-input-with-suffix text-input"
                    type="text"
                    name="movement"
                    placeholder={
                      primary == "assistant"
                        ? t("addSecondaryMovement.enterAssistantMovement")
                        : t("addSecondaryMovement.enterVariationName")
                    }
                    defaultValue={value}
                    maxLength="120"
                  />
                  {!PRIMARIES_WITHOUT_SUFFIX.includes(primary) && (
                    <span className="suffix-secondary-position load-suffix">
                      ({MOVEMENTS[primary] ?? capitalize(primary)})
                    </span>
                  )}
                </div>
              </div>
              {primary !== "assistant" && !isCatalog && (
                <div
                  className={
                    athlete ||
                    this.context.locals.pathname.includes(
                      "/dashboard/settings/exercise-library"
                    )
                      ? "w-1/2 mb-6"
                      : "hidden"
                  }
                >
                  <label>{t("addSecondaryMovement.repMaxLabel")}</label>
                  <UnitInput
                    metric="kg"
                    imperial="lb"
                    className="text-input"
                    name="repMaximum"
                    placeholder={t("addSecondaryMovement.repMaxPlaceholder")}
                    defaultValue={default1RMValue}
                    notRound="true"
                  />
                </div>
              )}
              <ExtraInputComponent
                videoUrl={videoUrl}
                videoFile={videoFile}
                videoOriginal={videoOriginal}
                exerciseTypeField={exerciseTypeField}
                primaryMuscleGroup={primaryMuscleGroup}
                secondaryMuscleGroup={secondaryMuscleGroup}
                instructions={instructions}
                handleInputChange={this.handleInputChange}
                cleanVideoField={this.cleanVideoField}
                form="add-secondary-exercise"
                overlay
              />
              <p>
                {t("addSecondaryMovement.movementWillBeSavedToLibrary", {
                  action: isNew
                    ? t("addSecondaryMovement.added")
                    : t("addSecondaryMovement.saved"),
                  primary: MOVEMENTS[primary] ?? capitalize(primary),
                })}
              </p>
            </div>
          </div>

          <footer>
            <a
              role="button"
              data-button-type="text-white"
              data-action="cancel"
              href="/actions/refresh?modal="
            >
              {t("common:cancel")}
            </a>
            <button data-button-type="primary" type="submit">
              {isNew ? t("common:add") : t("common:save")}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

AddSecondaryMovementModal.contextType = RillContext;

export { id };
export default withTranslation("coaching-portal")(AddSecondaryMovementModal);
